/**
 * Утилиты для управления версионированием приложения
 * Доступны в консоли браузера через window.versionUtils
 */

import versionService from './versionService'

const versionUtils = {
  /**
   * Получить информацию о текущей версии
   */
  info() {
    const info = versionService.getVersionInfo()
    console.table(info)
    return info
  },

  /**
   * Принудительно очистить кеш
   */
  async clearCache() {
    console.log('Очистка кеша...')
    await versionService.clearCache()
    console.log('Кеш очищен')
  },

  /**
   * Принудительно перезагрузить приложение
   */
  reload() {
    console.log('Принудительная перезагрузка...')
    versionService.forceReload()
  },

  /**
   * Проверить и обновить версию
   */
  async checkUpdate() {
    console.log('Проверка обновлений...')
    const updated = await versionService.checkAndUpdate()
    if (updated) {
      console.log('Приложение обновлено!')
    } else {
      console.log('Обновлений не найдено')
    }
    return updated
  },

  /**
   * Сбросить сохраненную версию (для тестирования)
   */
  resetVersion() {
    localStorage.removeItem('app_version')
    console.log('Сохраненная версия сброшена')
  },

  /**
   * Установить версию вручную (для тестирования)
   */
  setVersion(version) {
    versionService.setStoredVersion(version)
    console.log(`Версия установлена: ${version}`)
  },

  /**
   * Показать справку
   */
  help() {
    console.log(`
🔧 Утилиты версионирования приложения:

versionUtils.info()          - Информация о версии
versionUtils.clearCache()    - Очистить кеш
versionUtils.reload()        - Перезагрузить приложение
versionUtils.checkUpdate()   - Проверить обновления
versionUtils.resetVersion()  - Сбросить версию (тест)
versionUtils.setVersion(v)   - Установить версию (тест)
versionUtils.help()          - Показать справку
`)
  }
}

// Делаем утилиты доступными глобально в режиме разработки
if (process.env.NODE_ENV === 'development') {
  window.versionUtils = versionUtils
  console.log('🔧 Утилиты версионирования доступны через window.versionUtils')
  console.log('Введите versionUtils.help() для справки')
}

export default versionUtils